// extracted by mini-css-extract-plugin
export default {"container":"slide_container__ceNLb","imgContainer":"slide_imgContainer__9bsSp","details":"slide_details__guhmj"};